import { FieldPath, FieldPathValue, FieldValues, useWatch } from 'react-hook-form';
import { UseFieldWatchResult } from './types';
export function useFieldWatch<FD extends FieldValues>(name: FieldPath<FD>, defaultValue?: FieldPathValue<FD, FieldPath<FD>>): UseFieldWatchResult<FD> {
  return (useWatch({
    name,
    defaultValue
  }) as UseFieldWatchResult<FD>);
}